






















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ItemDeMenu } from '@/shareds/itensDeMenu'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import PedidoStore from '@/store/vuex/aplicacao/PedidoStore'

@Component({ name: 'SubmenuFlyout' })
export default class SubmenuFlyout extends Vue {
	@Prop({ type: Array, default: () => [] }) itens!: ItemDeMenu[]

	indiceAberto: number | null = null
	fecharTimeout: ReturnType<typeof setTimeout> | null = null
	posicao = { top: '0px', left: '0px' }

	abrir(indice: number, evento: MouseEvent) {
		if (this.fecharTimeout) clearTimeout(this.fecharTimeout)
		this.indiceAberto = indice
		const alvo = evento.currentTarget as HTMLElement
		const retangulo = alvo.getBoundingClientRect()
		this.posicao = { top: `${retangulo.top}px`, left: `${retangulo.right}px` }
	}

	agendarFechamento() {
		if (this.fecharTimeout) clearTimeout(this.fecharTimeout)
		this.fecharTimeout = setTimeout(() => {
			this.indiceAberto = null
		}, 200)
	}

	beforeDestroy() {
		if (this.fecharTimeout) clearTimeout(this.fecharTimeout)
	}

	obterCorDoItem(item: ItemDeMenu) {
		return this.temRotasAtivaDoItem(item)
			? 'primary'
			: (AppStore.modoNoturno ? 'white' : 'grey darken-2')
	}

	temRotasAtivaDoItem(item: ItemDeMenu): boolean {
		return !!((
			item.route &&
			typeof item.route !== 'string' &&
			this.$route.name === item.route.name
		) || (
			item.children &&
			item.children.some(this.temRotasAtivaDoItem)
		))
	}

	get devolucaoDePedidos() {
		return PedidoStore.devolucaoPedidos
	}

	get temDevolucoesPendentes() {
		return PedidoStore.devolucaoPedidos && Number(PedidoStore.devolucaoPedidos) > 0
	}

	get pedidos() {
		return PedidoStore.pedidos
	}

	get temPedidosPendentes() {
		return PedidoStore.pedidos && Number(PedidoStore.pedidos) > 0
	}
}
